<template lang="pug">
  transition(name="fade-smooth")
    .modal-mask
      .modal-wrapper
        .modal-container

          .modal-header
            div
              h3 Seleccionar trabajadores
              p.subtitle {{ nombreArea }}
            span.icon.close(@click="cerrar")
              i.fa.fa-times

          .modal-body

            .busqueda
              span.icon
                i.fa.fa-search
              input.input(
                type="text"
                v-model.trim="textoBusqueda"
                placeholder="Buscar por nombre o código..."
              )

            .seleccionar-todos
              label.checkbox
                input(
                  type="checkbox"
                  :checked="todosSeleccionados"
                  @change="seleccionarTodos"
                )
                span Seleccionar todos

              span.contador
                | {{ seleccionTemporal.length }} de
                | {{ trabajadoresFiltrados.length }} seleccionados

            .loading(v-if="isLoading")
              i.fa.fa-spinner.fa-spin
              span Cargando trabajadores...

            .sin-resultados(
              v-else-if="trabajadoresFiltrados.length === 0"
            )
              span No se encontraron trabajadores en esta área.

            .lista-trabajadores(v-else)
              label.trabajador(
                v-for="trabajador in trabajadoresFiltrados"
                :key="trabajador.codigo"
                :class="{ 'seleccionado': estaSeleccionado(trabajador) }"
              )
                input(
                  type="checkbox"
                  :value="trabajador.codigo"
                  v-model="seleccionTemporal"
                )

                .datos-trabajador
                  span.nombre {{ trabajador.nombre }}
                  span.detalle
                    | Código: {{ trabajador.codigo }}
                    span(v-if="trabajador.cargo")
                      |  - {{ trabajador.cargo }}

          .modal-footer
            button.button.button-secondary(
              type="button"
              @click="cerrar"
            )
              span Cancelar

            button.button.button-primary(
              type="button"
              @click="aceptar"
              :disabled="seleccionTemporal.length === 0"
            )
              i.fa.fa-check
              span
                | Aceptar
                template(v-if="seleccionTemporal.length")
                  |  ({{ seleccionTemporal.length }})
</template>

<script>
export default {
  name: 'ModalTrabajadoresArea',

  props: {
    trabajadores: {
      type: Array,
      default: () => []
    },

    seleccionados: {
      type: Array,
      default: () => []
    },

    nombreArea: {
      type: String,
      default: ''
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      textoBusqueda: '',
      seleccionTemporal: []
    }
  },

  computed: {
    trabajadoresFiltrados () {
      const texto = this.textoBusqueda.toLowerCase()

      if (!texto) {
        return this.trabajadores
      }

      return this.trabajadores.filter(trabajador => {
        const codigo = String(trabajador.codigo || '').toLowerCase()
        const nombre = String(trabajador.nombre || '').toLowerCase()
        const cargo = String(trabajador.cargo || '').toLowerCase()

        return (
          codigo.includes(texto) ||
          nombre.includes(texto) ||
          cargo.includes(texto)
        )
      })
    },

    todosSeleccionados () {
      if (this.trabajadoresFiltrados.length === 0) {
        return false
      }

      return this.trabajadoresFiltrados.every(trabajador =>
        this.seleccionTemporal.includes(trabajador.codigo)
      )
    }
  },

  watch: {
    seleccionados: {
      immediate: true,
      handler (valor) {
        this.seleccionTemporal = valor.map(trabajador =>
          typeof trabajador === 'object'
            ? trabajador.codigo
            : trabajador
        )
      }
    }
  },

  methods: {
    estaSeleccionado (trabajador) {
      return this.seleccionTemporal.includes(trabajador.codigo)
    },

    seleccionarTodos (event) {
      const marcar = event.target.checked
      const codigosFiltrados = this.trabajadoresFiltrados.map(
        trabajador => trabajador.codigo
      )

      if (marcar) {
        this.seleccionTemporal = [
          ...new Set([
            ...this.seleccionTemporal,
            ...codigosFiltrados
          ])
        ]

        return
      }

      this.seleccionTemporal = this.seleccionTemporal.filter(
        codigo => !codigosFiltrados.includes(codigo)
      )
    },

    aceptar () {
      const trabajadoresSeleccionados = this.trabajadores.filter(
        trabajador =>
          this.seleccionTemporal.includes(trabajador.codigo)
      )

      this.$emit('aceptar', trabajadoresSeleccionados)
    },

    cerrar () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  padding: 20px;
}

.modal-container {
  width: 650px;
  max-width: 100%;
  max-height: 85vh;
  margin: auto;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #dddddd;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.modal-header h3 {
  margin: 0;
}

.subtitle {
  margin: 5px 0 0;
  color: #777777;
}

.close {
  cursor: pointer;
  font-size: 18px;
}

.modal-body {
  padding: 20px;
}

.busqueda {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.busqueda .icon {
  margin-right: 8px;
}

.busqueda .input {
  width: 100%;
}

.seleccionar-todos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.contador {
  color: #666666;
  font-size: 13px;
}

.lista-trabajadores {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #dddddd;
}

.trabajador {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
}

.trabajador:last-child {
  border-bottom: none;
}

.trabajador:hover,
.trabajador.seleccionado {
  background: #f5f7ff;
}

.trabajador input {
  margin-right: 12px;
}

.datos-trabajador {
  display: flex;
  flex-direction: column;
}

.nombre {
  font-weight: 600;
}

.detalle {
  margin-top: 4px;
  color: #777777;
  font-size: 12px;
}

.modal-footer {
  padding: 15px 22px;
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.loading,
.sin-resultados {
  padding: 30px;
  text-align: center;
  color: #777777;
}

.loading span {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// c_modal_trabajadores_area.vue?617fbc3d